<template>
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path
      d="M5 21v-1H4a1 1 0 0 1 0-2h1v-1a1 1 0 1 1 2 0v1h1a1 1 0 0 1 0 2H7v1a1 1 0 1 1-2 0m8-19q.7 0 1 .7L16 9l5.4 2a1 1 0 0 1 0 1.8L16 15l-2.2 6.4a1 1 0 0 1-1.8 0L9.9 15l-5.3-2a1 1 0 0 1 0-1.8L10 9l2.2-6.4v-.2q.3-.5.9-.5M4 7V6H3a1 1 0 0 1 0-2h1V3a1 1 0 0 1 2 0v1h1a1 1 0 0 1 0 2H6v1a1 1 0 1 1-2 0"
    />
  </svg>
</template>
